import { render } from "./Side.vue?vue&type=template&id=e90c9444&scoped=true"
import script from "./Side.vue?vue&type=script&lang=js"
export * from "./Side.vue?vue&type=script&lang=js"

import "./Side.vue?vue&type=style&index=0&id=e90c9444&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e90c9444"]])

export default __exports__